import { Ref } from '@vue/composition-api';

export enum LinkType {
  Route,
  Logout,
  OpenChat
}

export interface NavItem {
  route: string;
  icon?: string;
  title: string;
  subtitle?: string;
  badgeNumber?: number;
  children?: NavItem[];
  newItem?: boolean;
  closed?: Ref<boolean>;
  disabled?: boolean;
  disabled_cta?: string;
  blocked?: boolean;
  redirect_to?: string;
}

export interface UserMenuItem {
  title: string;
  icon?: string;
  link?: string;
  type?: LinkType;
}
